import { type ReactNode } from 'react';

/**
 * Centered card layout shared by every public /admin/auth/* page. Lives in
 * `layout/` (not `pages/`) so it can be reused across login, totp, forgot,
 * reset, invite, and enroll without coupling pages to each other.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg p-4">
      <div className="w-full max-w-md rounded-2xl bg-surface border border-hairline p-8 shadow-[0_16px_40px_-20px_rgba(0,0,0,0.20)]">
        {children}
      </div>
    </div>
  );
}
